import { render, staticRenderFns } from "./external.vue?vue&type=template&id=5f3ac64d&"
import script from "./external.vue?vue&type=script&lang=ts&"
export * from "./external.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports